import React from 'react'
import  { LinkListProps } from './types'
import resolveProps from '../../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse'],
  states: []
}

const renderLinkList = (props, disabled) => {
  if (!props) return
  const listItems = props.map((link, index) => (
    <li key={index} className="mdn-LinkList-item">
      <a
        {...link.linkProps}
        className={`mdn-LinkList-anchor ${link.className}`}
        target={link.target}
        href={link.href}
        disabled={link.isDisabled || disabled}
      >
        {link.title}
      </a>
    </li>
  ))
  return listItems
}

export default function LinkList(props:LinkListProps) {
  const { data, disabled, className, inverse, ...rest } = props
  return (
    <ul {...rest} className={`${resolveProps(props, config, 'LinkList')}  ${className}`}>
      {renderLinkList(data, disabled)}
    </ul>
  )
}
